/// <reference types="@angular/localize" />
import '@brunata-angular/util/zod';

import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import {initTracing} from '@brunata-angular/util';

import {AppModule} from './app/app.module';
import {environment} from './environments/environment';

initTracing({
    serviceName: 'ngonline',
    environment: environment.brunataEnvironment,
    endpoint: environment.tracingEndpoint,
});

platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch(err => console.error(err));
